import React from "react";

type TContext = "ltr" | "rtl";
const LanguageContext = React.createContext<TContext>("ltr");

export default LanguageContext;
